import { SuperAdminInvite } from 'src/types/resources/SuperAdminInvite';
import apiRoutes from 'src/routes/apiRoutes';
import { ListRequestParams, ListResponse, SingleResponse } from 'src/types/utils';
import { emptyApi } from 'src/services/emptyApi';

export const invitesSuperadminApi = emptyApi.injectEndpoints({
  endpoints: builder => ({
    getInvitesForSuperadmin: builder.query<ListResponse<SuperAdminInvite>, ListRequestParams>({
      query: params => ({
        url: apiRoutes.superAdmin.invites(),
        params,
      }),
      providesTags: ['SuperadminInvites'],
    }),
    updateInviteEntityForSuperadmin: builder.mutation<
      SingleResponse<SuperAdminInvite>,
      { id: number; acquiredFromId: ID | null }
    >({
      query: ({ id, acquiredFromId }) => ({
        url: apiRoutes.superAdmin.invite(id),
        method: 'PATCH',
        body: { acquiredFromId },
      }),
      invalidatesTags: ['SuperadminInvites'],
    }),
    resendInviteForSuperadmin: builder.mutation<SingleResponse<SuperAdminInvite>, { id: number; message: string }>({
      query: ({ id, message }) => ({
        url: apiRoutes.superAdmin.inviteResendPath(id),
        method: 'POST',
        body: { message },
      }),
      invalidatesTags: ['SuperadminInvites'],
    }),
  }),
});

export const {
  useGetInvitesForSuperadminQuery,
  useUpdateInviteEntityForSuperadminMutation,
  useResendInviteForSuperadminMutation,
} = invitesSuperadminApi;
